export default class {
    _id;
    _name;
    _username;
    _postIndex;
    _type;
    _childs;

    get id() {
        return this._id
    }

    set id(value) {
        this._id = value
    }

    get name() {
        return this._name
    }

    set name(value) {
        this._name = value
    }

    get username() {
        return this._username
    }

    set username(value) {
        this._username = value
    }

    get postIndex() {
        return this._postIndex
    }

    set postIndex(value) {
        this._postIndex = value
    }

    get type() {
        return this._type
    }

    set type(value) {
        this._type = value
    }

    get childs() {
        return this._childs
    }

    set childs(value) {
        this._childs = value
    }

    constructor() {
        this._childs = []
    }
}